module.exports = __webpack_public_path__ + "img/2.0c5f76ab.jpg";